import i18n from "i18next";
import { initReactI18next } from "react-i18next";
const resources = {
    en: {
        translation: {
            validation: {
                required: "This field is required",
                email: {
                    invalid: "Please enter a valid email address",
                },
                phone: {
                    invalid: "Please enter a valid Mexican phone number",
                },
                verification: {
                    invalid: "Invalid verification code",
                },
                curp: {
                    invalid: "Please enter a valid CURP",
                },
                income: {
                    invalid: "Please enter a valid amount",
                },
                postalCode: {
                    invalid: "Please enter a valid postal code",
                },
                pin: {
                    invalid: "PIN must be 4 digits",
                },
            },
            errors: {
                network: {
                    default: "Network error. Please try again.",
                    timeout: "Request timed out. Please try again.",
                },
                unexpected: "An unexpected error occurred. Please try again.",
            },
        },
    },
    es: {
        translation: {
            validation: {
                required: "Este campo es obligatorio",
                email: {
                    invalid: "Por favor ingresa un correo electrónico válido",
                },
                phone: {
                    invalid: "Por favor ingresa un número de teléfono mexicano válido",
                },
                verification: {
                    invalid: "Código de verificación inválido",
                },
                curp: {
                    invalid: "Por favor ingresa un CURP válido",
                },
                income: {
                    invalid: "Por favor ingresa un monto válido",
                },
                postalCode: {
                    invalid: "Por favor ingresa un código postal válido",
                },
                pin: {
                    invalid: "El NIP debe tener 4 dígitos",
                },
            },
            errors: {
                network: {
                    default: "Error de red. Por favor intenta de nuevo.",
                    timeout: "La solicitud ha expirado. Por favor intenta de nuevo.",
                },
                unexpected: "Ha ocurrido un error inesperado. Por favor intenta de nuevo.",
            },
        },
    },
};
// Initialize i18next
i18n.use(initReactI18next).init({
    resources,
    lng: "es", // Default language
    fallbackLng: "es",
    interpolation: {
        escapeValue: false, // React already escapes by default
    },
});
export default i18n;
